import { Avatar, Button, Dialog, Typography } from "@/components/kit";
import useStoreMe from "@/hooks/store/useStoreMe";
import {
  Popover,
  PopoverContent,
  PopoverHandler,
} from "@material-tailwind/react";
import classNames from "classnames";
import { useState } from "react";
import ListItems from "./ListItems";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

function DropUpAccount() {
  const { me } = useStoreMe();
  const [open, setOpen] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleSignout = () => {
    queryClient.clear();
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("access_token");
    localStorage.removeItem("company");
    localStorage.removeItem("mainOffice");
    navigate("/auth/login");
    location.reload();
  };

  return (
    <>
      <Popover
        open={open}
        handler={() => setOpen((pre) => !pre)}
        placement="left-end"
        offset={0}
      >
        <PopoverHandler>
          <div className="p-4 flex flex-col gap-1 cursor-pointer w-full justify-center">
            <Avatar
              size="md"
              src={me?.profile ?? undefined}
              name={me?.firstName ?? ""}
            />
            <Typography
              block
              className="truncate"
              variant="Caption1-Medium"
            >{`${me?.firstName} ${me?.lastName}`}</Typography>
          </div>
        </PopoverHandler>
        <PopoverContent
          className={classNames(
            "p-3 w-[300px] z-[var(--buttons-menu-zIndex)] flex flex-col gap-2 border-0",
          )}
          placeholder=""
        >
          <div className="flex max-w-full gap-2 p-2 items-center truncate">
            <Avatar
              className="h-10 w-10"
              src={me?.profile ?? ""}
              name={me?.firstName ?? ""}
            />
            <div className="flex-grow flex flex-col">
              <Typography variant="Body1-Bold" color="text-gray-800" block>
                {`${me?.firstName} ${me?.lastName}`}
              </Typography>
              <Typography
                className="w-full"
                variant="Caption1-Regular"
                color="text-gray-400"
                block
                title={me?.email}
              >
                {me?.email}
              </Typography>
            </div>
            {/* <SvgIcon
              iconName="close"
              fill="fill-gray-600"
              className="w-[32px] h-[32px] cursor-pointer"
              onClick={() => setOpen(false)}
            /> */}
          </div>
          <div className="w-full h-[1px] bg-gray-50" />

          <ListItems
            setOpenConfirmDialog={setOpenConfirmDialog}
            handleClose={() => setOpen(false)}
          />
        </PopoverContent>
      </Popover>
      <Dialog
        title={"Sign Out"}
        body="Are you sure to Sign Out?"
        handler={() => setOpenConfirmDialog(false)}
        open={openConfirmDialog}
      >
        <Button variant="filled" color="red" onClick={handleSignout}>
          Sign Out
        </Button>
        <Button onClick={() => setOpenConfirmDialog(false)}>cancel</Button>
      </Dialog>
    </>
  );
}

export default DropUpAccount;
